<nz-page-header class="site-page-header">
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <a routerLink="..">
        <i nz-icon nzType="home"></i>
      </a>
    </nz-breadcrumb-item>
    <nz-breadcrumb-item>
      <i nz-icon nzType="camera"></i>
      Câmera Analítica
    </nz-breadcrumb-item>
  </nz-breadcrumb>
</nz-page-header>

<div class="px-4 mb-2 control-toolbar">
  <div class="mr-2 mt-2">
    <app-search-filter
      [dropdownOptions]="generalSearchOptions"
      (onFilter)="handleGeneralSearchFilter($event)"
      (onClose)="closeGeneralSearchFilter()"></app-search-filter>
  </div>
  <div class="mr-2 mt-2">
    <app-search-whitelabel (onFilter)="handleWhitelabelFilter($event)" (onClose)="closeWhitelabelFilter()"></app-search-whitelabel>
  </div>
  <div class="mr-2 mt-2">
    <app-search-dropdown
      [dropdownOptions]="planOptions"
      (onFilter)="handleSearchPlanFilter($event)"
      (onClose)="closeSearchPlanFilter()"></app-search-dropdown>
  </div>

  <nz-button-group class="mt-2">
    <button (click)="toggleShowDeleted()" nz-button [nzType]="showDeleted ? 'default' : 'primary'">
      Mostrar apenas {{ showDeleted ? 'não' : '' }} excluídos
    </button>
  </nz-button-group>

  <nz-button-group class="mt-2">
    <button nz-button (click)="exportAsCsv(tableFields, condos)">
      <i nz-icon nzType="file-excel" nzTheme="outline"></i>
      Excel
    </button>
    <button nz-button (click)="exportAsPDF(tableFields, condos)">
      <i nz-icon nzType="file-pdf" nzTheme="outline"></i>
      PDF
    </button>
  </nz-button-group>
</div>

<div class="px-4">
  <div *ngIf="loadingStatus === 'LOADING'" class="my-5" style="display: flex; justify-content: center">
    <span>Carregando...</span>
  </div>

  <div *ngIf="loadingStatus === 'ERROR'" class="my-5">
    <h2 nz-typography nzType="danger">Erro ao carregar destaques</h2>
    <h4 nz-typography>Ocorreu um erro ao carregar os destaques. Tente novamente, por favor.</h4>
    <button nz-button nzType="primary" (click)="getData()">Tentar novamente</button>
  </div>

  <nz-table *ngIf="loadingStatus === 'SUCCESS'" #condosTable [nzData]="condos" [nzFrontPagination]="false">
    <thead>
      <tr>
        <th>ID</th>
        <th (click)="getSortedData('name')" nz-tooltip nzTooltipTitle="Clique para ordenar">
          Nome
          <i
            nz-icon
            nzType="{{ sortSetting.field === 'name' ? (sortSetting.order === 'asc' ? 'up' : 'down') : 'sort-descending' }}"
            nzTheme="outline"></i>
        </th>
        <th>Whitelabel</th>
        <th>Câmeras</th>
        <th>Valor total</th>
        <th *ngIf="showDeleted">Excluido por</th>
        <th *ngIf="showDeleted">Data de exclusão</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let condo of condosTable.data; let i = index">
        <td>
          {{ condo?._id }}
        </td>
        <td>{{ condo?.name }}</td>
        <td>
          {{ condo?.whiteLabel?.name || 'Não possui' }}
        </td>
        <td>
          {{ condo?.eCameraParams?.enabled ? condo?.eCameraParams?.camerasLimit || 0 : 0 }}
        </td>
        <td>
          {{
            (condo?.eCameraParams?.enabled
              ? (condo?.eCameraParams?.camerasLimit || 0) * ((condo?.eCameraParams?.pricePerCamera || 0) / 100)
              : 0
            ) | number: '1.2-2'
          }}
        </td>
        <td *ngIf="showDeleted">{{ condo.deletedBy?.firstName }} {{ condo.deletedBy?.lastName }}</td>
        <td *ngIf="showDeleted">{{ condo.deletedAt | date: 'dd/MM/yyyy' }}</td>
        <td>
          <nz-button-group>
            <button [routerLink]="['..', 'condos', condo?._id]" nz-button nzType="primary">Detalhes</button>
          </nz-button-group>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <nz-pagination
    nz-row
    nzJustify="end"
    nzShowSizeChanger
    [nzTotal]="totalCondos"
    [nzPageIndex]="0"
    [nzPageSize]="nzPageSize"
    [nzPageSizeOptions]="[50, 100, 250, 500]"
    (nzPageIndexChange)="refreshIndexChange($event)"
    (nzPageSizeChange)="refreshSizeChange($event)"></nz-pagination>
</div>
